<form #errorCalcForm="ngForm" class="m-0 p-0">
    
    <div *ngIf="scoutPoint" class="content-div pb-1">


    <div class="title-bar text-center text-nowrap"
            [ngStyle]="{'background-color': scoutPoint.color}">
        Error Calculation
    </div>

    <div *ngIf="scoutPoint" class="px-sm-1">
        <table class="table table-striped table-sm m-0 p-0">
        <thead>
        </thead>
        <tbody>
            <tr><td class="units-cell pt-sm-1"></td></tr>
            <tr>
                <td colspan="6" class="header-cell">
                    Horizontal
                </td>
            </tr>
            <tr><td class="units-cell pt-sm-1"></td></tr>
            <tr>
                <td class="label-cell">{{scoutPoint.type=='HA'?'Survey':'Implementation'}}</td>
                <td class="value-cell">
                    <div *ngIf="!isEditing" role="button" (click)="onEdit()">
                        {{scoutPoint.horizontalError.implConstant|number:ConstantPrecisionFormat}}
                    </div>
                    <ng-container *ngIf="isEditing">
                        <input name="hImplConstant" type='number' class="constant-input" number [min]="0"
                            [(ngModel)]="scoutPoint.horizontalError.implConstant" #hImplConstant="ngModel"
                            [ngClass]="{ 'invalid-input': hImplConstant.invalid && (hImplConstant.dirty || hImplConstant.touched)}">
                    </ng-container>
                </td>
                <td class="units-cell">m</td>
                <td class="units-cell"></td>
                <td class="value-cell">{{scoutPoint.horizontalError.implEstimate|number:ErrorPrecisionFormat}}</td>
                <td class="units-cell">m</td>
            </tr>
            <tr>
                <td class="label-cell">External Wall Angle</td>
                <td class="value-cell">
                    <div *ngIf="!isEditing" role="button" (click)="onEdit()">
                        {{scoutPoint.horizontalError.externalWallAngleConstant|number:ConstantPrecisionFormat}}
                    </div>
                    <ng-container *ngIf="isEditing">
                        <input name="hExternalWallAngleConstant" type='number' class="constant-input" number [min]="0"
                            [(ngModel)]="scoutPoint.horizontalError.externalWallAngleConstant" #hExternalWallAngleConstant="ngModel"
                            [ngClass]="{ 'invalid-input': hExternalWallAngleConstant.invalid && (hExternalWallAngleConstant.dirty || hExternalWallAngleConstant.touched)}">
                    </ng-container>
                </td>
                <td class="units-cell">deg</td>
                <td class="units-cell"></td>
                <td class="value-cell">{{scoutPoint.horizontalError.externalWallAngleEstimate|number:ErrorPrecisionFormat}}</td>
                <td class="units-cell">m</td>
            </tr>
            <tr>
                <td class="label-cell">Measured Angle</td>
                <td class="value-cell">
                    <div *ngIf="!isEditing" role="button" (click)="onEdit()">
                        {{scoutPoint.horizontalError.measuredAngleConstant|number:ConstantPrecisionFormat}}
                    </div>
                    <ng-container *ngIf="isEditing">
                        <input name="hMeasuredAngleConstant" type='number' class="constant-input" number [min]="0"
                            [(ngModel)]="scoutPoint.horizontalError.measuredAngleConstant" #hMeasuredAngleConstant="ngModel"
                            [ngClass]="{ 'invalid-input': hMeasuredAngleConstant.invalid && (hMeasuredAngleConstant.dirty || hMeasuredAngleConstant.touched)}">
                    </ng-container>
                </td>
                <td class="units-cell">deg</td>
                <td class="units-cell">+</td>
                <td class="value-cell" style="border-bottom: 2px solid gray;">
                    {{scoutPoint.horizontalError.measuredAngleEstimate|number:ErrorPrecisionFormat}}
                </td>
                <td class="units-cell">m</td>
            </tr>
            <tr><td class="units-cell pt-sm-1"></td></tr>
            <tr>
                <td colspan="4" class="label-cell">Segment</td>
                <td class="value-cell">{{scoutPoint.horizontalError.segmentEstimate|number:ErrorPrecisionFormat}}</td>
                <td class="units-cell">m</td>
            </tr>
            <tr>
                <td colspan="4" class="label-cell">Cumulative</td>
                <td class="value-cell">{{scoutPoint.horizontalError.cumulativeEstimate|number:ErrorPrecisionFormat}}</td>
                <td class="units-cell">m</td>
            </tr>
            <tr><td class="units-cell p-0"></td></tr>
            <tr><td class="units-cell pt-sm-1"></td></tr>
            <tr>
                <td colspan="6" class="header-cell">
                    Vertical
                </td>
            </tr>
            <tr><td class="units-cell pt-sm-1"></td></tr>
            <tr>
                <td class="label-cell">{{scoutPoint.type=='HA'?'Survey':'Implementation'}}</td>
                <td class="value-cell">
                    <div *ngIf="!isEditing" role="button" (click)="onEdit()">
                        {{scoutPoint.verticalError.implConstant|number:ConstantPrecisionFormat}}
                    </div>
                    <ng-container *ngIf="isEditing">
                        <input name="vImplConstant" type='number' class="constant-input" number [min]="0"
                            [(ngModel)]="scoutPoint.verticalError.implConstant" #vImplConstant="ngModel"
                            [ngClass]="{ 'invalid-input': vImplConstant.invalid && (vImplConstant.dirty || vImplConstant.touched)}">
                    </ng-container>
                </td>
                <td class="units-cell">m</td>
                <td class="units-cell"></td>
                <td class="value-cell">{{scoutPoint.verticalError.implEstimate|number:ErrorPrecisionFormat}}</td>
                <td class="units-cell">m</td>
            </tr>
            <tr>
                <td class="label-cell">Level Floor Variance</td>
                <td class="value-cell">
                    <div *ngIf="!isEditing" role="button" (click)="onEdit()">
                        {{scoutPoint.verticalError.floorVarianceConstant|number:ConstantPrecisionFormat}}
                    </div>
                    <ng-container *ngIf="isEditing">
                        <input name="vFloorVarianceConstant" type='number' class="constant-input" number [min]="0"
                            [(ngModel)]="scoutPoint.verticalError.floorVarianceConstant" #vFloorVarianceConstant="ngModel"
                            [ngClass]="{ 'invalid-input': vFloorVarianceConstant.invalid && (vFloorVarianceConstant.dirty || vFloorVarianceConstant.touched)}">
                    </ng-container>
                </td>
                <td class="units-cell">m</td>
                <td class="units-cell"></td>
                <td class="value-cell">{{scoutPoint.verticalError.floorVarianceEstimate|number:ErrorPrecisionFormat}}</td>
                <td class="units-cell">m</td>
            </tr>
            <tr>
                <td class="label-cell">Unlevel Floor</td>
                <td class="value-cell">
                    <div *ngIf="!isEditing" role="button" (click)="onEdit()">
                        {{scoutPoint.verticalError.unlevelFloorConstant|number:ConstantPrecisionFormat}}
                    </div>
                    <ng-container *ngIf="isEditing">
                        <input name="vUnlevelFloorConstant" type='number' class="constant-input" number [min]="0"
                            [(ngModel)]="scoutPoint.verticalError.unlevelFloorConstant" #vUnlevelFloorConstant="ngModel"
                            [ngClass]="{ 'invalid-input': vUnlevelFloorConstant.invalid && (vUnlevelFloorConstant.dirty || vUnlevelFloorConstant.touched)}">
                    </ng-container>
                </td>
                <td class="units-cell">m</td>
                <td class="units-cell">+</td>
                <td class="value-cell" style="border-bottom: 2px solid gray;">
                    {{scoutPoint.verticalError.unlevelFloorEstimate|number:ErrorPrecisionFormat}}
                </td>
                <td class="units-cell">m</td>
            </tr>
            <tr><td class="units-cell pt-sm-1"></td></tr>
            <tr>
                <td colspan="4" class="label-cell">Segment</td>
                <td class="value-cell">{{scoutPoint.verticalError.segmentEstimate|number:ErrorPrecisionFormat}}</td>
                <td class="units-cell">m</td>
            </tr>
            <!--
            <tr>
                <td colspan="4" class="label-cell">Cumulative</td>
                <td class="value-cell">{{scoutPoint.verticalError.cumulativeEstimate|number:ErrorPrecisionFormat}}</td>
                <td class="units-cell">m</td>
            </tr>
            -->
        </tbody>
        </table>
    </div>
</div>
</form>